import React from 'react';

const introduction = "DS Smith management look forward to discussing the company's business model, growth strategy, and financial outlook.";
const contact = "If you would like to contact DS Smith's Investor Relations team, please email ";
const email = 'InvestorRelations@dssmith.com';
const emailHref = 'mailto:investorrelations@dssmith.com';

export const DS_SMITH_EVENT = {
  id: '6aa9548bba91570013153fcd',
  dateLabel: 'Tuesday 3rd November 1pm-5pm GMT (8am-12pm ET)',
  websiteUrl: 'https://www.dssmith.com/?utm_source=Referral&utm_medium=IR_webcast&utm_campaign=Investor-day-2026',
  description: `${introduction}\n\n${contact}${email}`,
  calendarHtmlDescription: `${introduction}<br><br>${contact}<a href="${emailHref}">${email}</a>`,
};

const DsSmithDescription = () => (
  <>
    {introduction}
    <br />
    <br />
    {contact}
    <a
      href={emailHref}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {email}
    </a>
  </>
);

export default DsSmithDescription;
